export const SET_OUTSIDER_INVITED_PROCESSING =
  "SET_OUTSIDER_INVITED_PROCESSING";
